/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PosSessionApproverDto } from '../../models/pos-session-approver-dto';

export interface PosSessionsControllerGetApprovers$Params {
}

export function posSessionsControllerGetApprovers(http: HttpClient, rootUrl: string, params?: PosSessionsControllerGetApprovers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PosSessionApproverDto>>> {
  const rb = new RequestBuilder(rootUrl, posSessionsControllerGetApprovers.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PosSessionApproverDto>>;
    })
  );
}

posSessionsControllerGetApprovers.PATH = '/pos/sessions/approvers';
